<template>
	<div class="">
		<el-dialog :title="tits" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false"
			:before-close="handleClose">
			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="120px" class="demo-editForm">
				<el-form-item label="商品名" prop="name" label-width="120px">
					<el-input v-model="editForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item label="商品分类" prop="classifyId" label-width="120px">
					<el-cascader placeholder="选择分类" :options="typeList" v-model="classifyId"
						:props="{ value: 'id', label: 'name', children: 'children' }" @change="onSelectPMenu"
						ref="cateData" clearable filterable></el-cascader>
				</el-form-item> -->
				<el-form-item label="收益规则" prop="awardId" label-width="120px">
					<el-select v-model="editForm.awardId" filterable placeholder="选择收益规则">
						<el-option v-for="(item, index) in awList" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否是周边商品" label-width="120px" prop="isHot">
					<el-radio-group v-model="editForm.isPerimeter">
						<el-radio :label="0">是</el-radio>
						<el-radio :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label-width="120px" label="单位" prop="unit">
					<el-input v-model="editForm.unit" autocomplete="off"></el-input>
				</el-form-item> -->
				<!-- 
				<el-form-item label="限时优惠" label-width="120px" prop="isLimitedTimeDiscount">
					<el-radio-group v-model="editForm.isLimitedTimeDiscount">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="新品上市" label-width="120px" prop="isNewProductLaunch">
					<el-radio-group v-model="editForm.isNewProductLaunch">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<el-form-item label="商品原价" prop="originalPrice" label-width="120px">
					<el-input v-model="editForm.originalPrice" :disabled='f' vautocomplete="off"
						type="number"></el-input>
				</el-form-item>
				<el-form-item label="商品现价" prop="price" label-width="120px">
					<el-input v-model="editForm.price" :disabled='f' autocomplete="off" type="number"></el-input>
				</el-form-item>


				<el-form-item label="商品规格" label-width="120px" prop="tcommoditySpecifications">
					<div v-for="(item, index) in editForm.tcommoditySpecifications" :key="index">
						<el-row>
							<el-col style="width: 12%;">
								<el-form-item label="规格" label-width="60px">
									<el-input v-model="editForm.tcommoditySpecifications[index]
										.specifications
										" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>

							<el-col style="width: 12%;">
								<el-form-item label="单价" label-width="60px">
									<el-input type="number"
										v-model.number="editForm.tcommoditySpecifications[index].specificationsPrice"></el-input>
								</el-form-item>
							</el-col>
							<el-col style="width: 12%;">
								<el-form-item label="库存" label-width="60px">
									<el-input type="number"
										v-model.number="editForm.tcommoditySpecifications[index].inventory"></el-input>
								</el-form-item>
							</el-col>
							<el-col style="width: 14%;">
								<el-form-item label="重量(kg)" label-width="80px">
									<el-input type="number"
										v-model="editForm.tcommoditySpecifications[index].goodWeight"
										placeholder="输入0免邮"></el-input>
								</el-form-item>
							</el-col>

							<el-col style="width: 40%;">
								<el-form-item label="规格图片(尺寸1:1)" label-width="160px">
									<VploadImgs :limit="1" :limits="index"
										v-bind:file-list="editForm.tcommoditySpecifications[index].specificationsImgList"
										:file-type="1" @submitImg="getImgList2">
									</VploadImgs>
								</el-form-item>
							</el-col>

							<el-col style="width: 10%;">
								<i class="el-icon-circle-plus-outline" style="color: #67c23a; margin: 0 30px;"
									@click="add1(index)"></i>
								<i class="el-icon-delete" style="color: #f56c6c;" @click="del1(index)"></i>
							</el-col>
						</el-row>
					</div>
				</el-form-item>
				<el-form-item label="起订数量" prop="startBuy" label-width="120px">
					<el-input type="number" v-model.number="editForm.startBuy" autocomplete="off" style="width: 200px;"
						@input="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="商品说明" prop="explain" label-width="120px">
					<el-input v-model="editForm.explain" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="商品详情" prop="imgDetail" label-width="120px">
					<div id="wange"></div>
				</el-form-item>
				<!-- 	<el-form-item label-width="120px" label="商品参数" prop="parameters">
					<el-input v-model="editForm.parameters" autocomplete="off"></el-input>
				</el-form-item> -->
				<div style="height: 30px;"></div>
				<el-form-item label="轮播图(尺寸1:1)" prop="imgList" label-width="140px">
					<VploadImg :limit="5" v-bind:file-list="fileList" :multble="false" @submitImg="getImgList">
					</VploadImg>
				</el-form-item>
				<el-form-item align="center">
					<el-button type="primary" @click="saveAndNext('editForm')">保存</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

	</div>

</template>

<script>
	import E from 'wangeditor';
	import ty from '../../../utils/ty';
	import TinymceEditor from "../../inc/TinymceEditor";
	import VploadImgs from "../../inc/VploadImgThree";
	import VploadImg from "../../inc/VploadImgTwo";
	export default {
		name: "SingProduct",
		components: {
			VploadImg,
			VploadImgs,
			TinymceEditor,
		},
		props: {
			storeGoodsId: {
				type: Number,
			},
			storeGoodsStatus: {
				type: Number
			}
		},
		mounted() {
			var that = this
			setTimeout(function() {
				console.log('999', document.getElementById("wange"))
				// wangeditor
				that.elementById = document.getElementById("wange");
				that.editor = new E('#wange')
				// 配置 server 接口地址
				that.editor.config.debug = true;
				// 关闭粘贴内容中的样式
				that.editor.config.pasteFilterStyle = false
				// 忽略粘贴内容中的图片
				that.editor.config.pasteIgnoreImg = true
				// 使用 base64 保存图片
				//editor.customConfig.uploadImgShowBase64 = true
				// 上传图片到服务器
				that.editor.config.uploadImgServer = ty.apiurl + '/common/uploadFileUrl'
				that.editor.config.uploadFileName = 'file'
				that.editor.config.customUploadImg = (resultFiles, insertImgFn) => {

					that.SetImage(resultFiles[0]).then(res => {
						insertImgFn(res.msg);
					});

				};
				that.editor.config.uploadImgHooks = {

					success: function(xhr, editor, result) {
						console.log("999999999", xhr, editor, result)
						// 图片上传并返回结果，图片插入成功之后触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
					},
					fail: function(xhr, editor, result) {
						console.log("888888888888", xhr, editor, result)
						// 图片上传并返回结果，但图片插入错误时触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
					},
					error: function(xhr, editor) {
						console.log("1212121212112", xhr, editor)
						// 图片上传出错时触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
					}

				}
				that.editor.create()
				that.editor.config.onchange = html => {
					that.editForm.imgDetail = html;
				};
				console.log('777', that.editForm.imgDetail)
				that.editor.txt.html(that.editForm.imgDetail)
			}, 500)
		},
		data() {
			return {
				editForm: {
					imgList: [],
					imgDetail: '',
					isPerimeter:1
				},
				fileList: [],
				relGardenName: '',
				fileLists: [],
				//规格图片列表
				fileList2: [],
				filesd: [],
				banlist: [],
				typeList: [],
				urlList: [],
				supList: [],
				brolist: [],
				adrssData: [],
				id: '',
				fengbron: [],
				fengone: [],
				fengtwo: [],
				fengtress: [],
				cover: '',
				storeGoodsPackageList: [],
				totalCartons: 0,
				ispostage: false,
				dialogFormVisibleAdd: false,
				dialogVisible: true,
				getTagvisible: false,
				getGardenvisible: false,
				editFormRules: {
					name: [{
						required: true,
						message: '请输入商品名',
						trigger: 'blur'
					}],
					// classifyId: [{
					// 	required: true,
					// 	message: '请选择分类',
					// 	trigger: 'blur'
					// }],
					// unit: [{
					// 	required: true,
					// 	message: '请输入单位',
					// 	trigger: 'blur'
					// }],
					// isHot: [{
					// 	required: true,
					// 	message: '请选择是否是热门',
					// 	trigger: 'blur'
					// }],
					// isLimitedTimeDiscount: [{
					// 	required: true,
					// 	message: '请选择是否是限时优惠',
					// 	trigger: 'blur'
					// }],
					// isNewProductLaunch: [{
					// 	required: true,
					// 	message: '请选择是否是新品上市',
					// 	trigger: 'blur'
					// }],
					originalPrice: [{
						required: true,
						message: '请输入商品原价',
						trigger: 'blur'
					}],
					price: [{
						required: true,
						message: '请输入商品现价',
						trigger: 'blur'
					}],
					tcommoditySpecifications: [{
						required: true,
						message: '请输入商品规格',
						trigger: 'blur'
					}],
					startBuy: [{
						required: true,
						message: '请输入起购量',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '请输入数字',
						trigger: 'blur'
					}],
					explain: [{
						required: true,
						message: '请输入商品说明',
						trigger: 'blur'
					}],
					imgDetail: [{
						required: true,
						message: '请输入商品详情',
						trigger: 'blur'
					}],
					
					imgList: [{
						required: true,
						message: '请输入轮播图',
						trigger: 'blur'
					}],

				},
				bled: false,
				classifyId: [],
				editor: '',
				elementById: '',
				did: '',
				tits: '添加商品',
				f: false,
				awList: []
			}
		},
		watch: {
			storeGoodsId(n, o) { //n为新值,o为旧值;
				this.storeGoodsId = n
			},
			storeGoodsStatus(n, o) {
				this.storeGoodsStatus = n
			}
		},
		created() {
			this.getTypeList()
			this.supp()

		},
		methods: {
			inputChange() {
				if (this.editForm.startBuy <= 0) {
					this.editForm.startBuy = 1
				}
			},
			SetImage(item) {
				var that = this;
				console.log("555", item)
				return new Promise((resolve, reject) => {
					var fileData = new FormData();
					fileData.append('file', item);
					fileData.append('fileType', 0);
					fileData.append('type', 0);
					that.$axios.post(ty.apiurl + '/common/uploadFileUrl', fileData).then(res => {
						resolve(res);
					});
				});
			},
			change(val) {
				this.editForm.imgDetail = val;
			},
			resetForm(e) {
				this.classifyId = e
			},
			supp() {
				this.$axios.get("/admin/brand/getBrandListNoPage").then(res => {
					this.supList = res.data;
				})
			},
			onSelectPMenu(val) {
				console.log("777")
				// if (val.length == 0) {
				// 	this.$refs.cateData.$refs.panel.checkedValue = [];
				// 	this.$refs.cateData.$refs.panel.clearCheckedNodes();
				// 	this.$refs.cateData.$refs.panel.activePath = [];
				// 	this.$refs.cateData.$refs.panel.syncActivePath();
				// }
				// let selectLabel = this.$refs["cateData"].getCheckedNodes();
				// selectLabel = selectLabel.length == 0 ? "" : selectLabel[0].data.category_id;
			},

			init(e, d, f) {
				var that = this
				that.did = d
				console.log('666', f)
				if (f) {

					that.f = true
				} else {
					that.f = false
				}
				if (e) {
					this.id = e
					if (d) {
						this.tits = '编辑商品'
					} else {
						this.tits = '添加商品'
					}
					this.bled = true
					this.$axios.post('/admin/commodity/getCommodityDetail', {
						id: e
					}).then(res => {
						console.log(res);
						var dat = res.data
						var arrm = []
						this.editForm = dat
						this.editForm.tcommoditySpecifications.map((ites, index) => {
							ites.specificationsImgList = [{
								url: ites.specificationsImg
							}]
						})

						var cass = []
						setTimeout(function() {
							cass[0] = Number(dat.firstClassifyId)
							cass[1] = "a" + dat.classifyId
							that.resetForm(cass)
						}, 400)
						this.fengtwo = dat.imgList
						this.fileList = []
						this.fengtwo.map((item, index) => {
							var filess = {
								url: item
							}
							this.fileList.push(filess)
						})
						if (that.editor != '') {
							that.editor.txt.html(dat.imgDetail)
						}
					})
					that.dialogVisible = true;
				} else {
					this.tits = '添加商品'
					this.bled = false
					this.editForm = {
						classifyId: '',
						explain: '',
						imgDetail: '',
						imgList: [],
						isHot: 0,
						isLimitedTimeDiscount: 0,
						isNewProductLaunch: 0,
						name: '',
						startBuy: 1,
						originalPrice: '',
						parameters: '',
						price: '',
						videoCover: '',
						videoId: '',
						videoUrl: '',
						brandId: '',
						awardId: '',
						tcommoditySpecifications: [{
							specifications: '',
							specificationsPrice: '',
							specificationsImg: [],
							goodWeight: ''
						}],
						unit: '',
					}

					this.id = ''
					this.classifyId = []
					this.fileList = []
					this.fileLists = []
					this.filesd = []
					this.fengone = []
					this.fengtwo = []
					this.dialogVisible = true;
					that.editor.txt.html('')

				}


			},
			add1(i) {
				this.editForm.tcommoditySpecifications.splice(i + 1, 0, {
					specifications: "",
					specificationsPrice: "",
					specificationsImgList: [],
					tcommodityId: this.editForm.id || null,
					goodWeight: ''
				});
			},
			del1(i) {
				if (this.editForm.tcommoditySpecifications.length == 1) {
					this.editForm.tcommoditySpecifications = [{
						specifications: "",
						specificationsPrice: "",
						specificationsImgList: [],
						goodWeight: ''

					}, ];
				} else {
					this.editForm.tcommoditySpecifications.splice(i, 1);
				}
			},
			handleClose() {
				this.$refs.editForm.resetFields();
				this.editForm = {
					classifyId: '',
					explain: '',
					imgDetail: '',
					imgList: [],
					isHot: 0,
					isLimitedTimeDiscount: 0,
					isNewProductLaunch: 0,
					name: '',
					originalPrice: '',
					parameters: '',
					price: '',
					tcommoditySpecifications: [],
					unit: '',
				}
				this.id = ''
				this.fileList = []
				this.fileLists = []
				this.filesd = []
				this.fengone = []
				this.fengtwo = []
				this.fengtress = []
				this.dialogVisible = false
			},


			getTypeList() {
				// this.$axios.get("/admin/commodityClassify/getAllLevelList").then(res => {
				// 	this.typeList = res.data;
				// })
				this.$axios.get("/admin/rule/withlist").then(res => {
					this.awList = res.data;
				})
			},
			getImgList(url, add) {
				if (add == 1) {
					this.fengtwo.push(url)
				} else if (add == 0) {
					if (this.fengtwo == null || this.fengtwo.length < 1) {
						return;
					}
					this.fengtwo.some((item, i) => {
						if (item == url) {
							this.fengtwo.splice(i, 1)
							//在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
							return true
						}
					})
				}
				this.editForm.imgList = this.fengtwo;
			},
			getImgList2(url, add, e) {
				console.log("555", url, add, e);
				if (add == 1) {
					this.editForm.tcommoditySpecifications[e].specificationsImg = url;
				} else if (add == 0) {
					this.editForm.tcommoditySpecifications[e].specificationsImg = '';
				}
			},

			getImg(url, add) {

				if (add == 1) {
					this.fengone.push(url)
				} else if (add == 0) {
					if (this.fengone == null || this.fengone.length < 1) {
						return;
					}
					this.fengone.some((item, i) => {
						if (item == url) {
							this.fengone.splice(i, 1)
							//在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
							return true
						}
					})

				}

				this.editForm.videoCover = this.fengone.join(",");
			},
			//   保存并下一步
			saveAndNext(formName) {
				// if (this.classifyId.length > 0) {
				// 	this.typeList.map(item => {
				// 		item.children.map(itrs => {
				// 			if (this.classifyId[1] == itrs.id) {
				// 				this.editForm.classifyId = itrs.uid
				// 			}
				// 		})
				// 	})
				// } else {
				// 	this.searchForm.classifyId = ''
				// }
				// console.log(this.editForm.tcommoditySpecifications.some(item => {
				// 	return item.goodWeight <= 0
				// }));
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let flag = this.editForm.tcommoditySpecifications.some(item => {
							console.log(item.goodWeight);
							return item.goodWeight < 0 || item.goodWeight === '' || item.goodWeight ===
								null
						})
						if (flag) {
							this.$message({
								showClose: true,
								message: '商品规格重量不能小于0,且不为空',
								type: 'error',
							});
						} else {
							if (this.id && this.did == 1) {
								this.editForm.id = this.id
								console.log(this.editForm);
								this.$axios.post('/admin/commodity/updateCommodity', this.editForm)
									.then(res => {
										this.dialogVisible = false
										this.$emit('refreshDataList')
										this.$parent.$parent.storeGoodsStatus = this.editForm.status
										this.$message({
											showClose: true,
											message: '恭喜你，操作成功',
											type: 'success',
											onClose: () => {
												this.$emit("changeComponent1Data", 1)
											}
										});
									})
							} else {
								this.$axios.post('/admin/commodity/addCommodity', this.editForm)
									.then(res => {
										this.dialogVisible = false
										this.$emit('refreshDataList')
										this.$parent.$parent.storeGoodsStatus = this.editForm.status
										this.$message({
											showClose: true,
											message: '恭喜你，操作成功',
											type: 'success',
											onClose: () => {
												this.$emit("changeComponent1Data", 1)
											}
										});
									})
							}
						}
					}
				})
			},
		}
	}
</script>

<style scoped>
	>>>.el-upload-dragger {
		width: 148px;
		height: 148px;
	}
</style>